import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { GetAllAccountsByStore, DeleteAccount } from "../../api";
import { Header, Button } from "../../components";
import "../../styles/viewCustomer.css";
import { useStateContext } from "../../contexts/ContextProvider";
import { Col, Container, Row } from "react-bootstrap";
import { usePromiseTracker, trackPromise } from "react-promise-tracker";
import {
  showSuccessToast,
  showErrorToast,
  showInfoToast,
} from "../../components/ToastMesg";
import DataGrid from "../../components/DataGrid";

const Account = () => {
  const navigate = useNavigate();
  const { storeG, userPermID } = useStateContext();
  const [AllAccounts, setAllAccounts] = useState("");
  const [Account_id, setAccount_id] = useState("");
  const { promiseInProgress } = usePromiseTracker();
  const [loading, setloading] = useState(false);

  const accGrid = [
    {
      headerText: "Account Name",
      field: "name",
      minWidth: "180",
      width: "220",
      maxWidth: "640",
      textAlign: "left",
    },
    {
      field: "description",
      headerText: "Description",
      minWidth: "160",
      width: "320",
      maxWidth: "590",
      textAlign: "left",
    },
    {
      field: "type",
      headerText: "Type",
      minWidth: "120",
      width: "130",
      maxWidth: "200",
      textAlign: "left",
    },
    {
      field: "balance",
      headerText: "Balance",
      format: "C2",
      minWidth: "125",
      width: "130",
      maxWidth: "280",
      textAlign: "right",
    },
  ];

  const handleAddAccountClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    navigate(`/Account/AddAccount`);
  };

  const handleEditAccountClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    if (Account_id !== "") navigate(`/Account/EditAccount/${Account_id}`);
    else showInfoToast("Info!", "Please select account to edit.");
  };

  const handleDeleteAccountClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    try {
      if (Account_id !== "") {
        if (window.confirm(`Are you sure you want to Delete this Account?`)) {
          const response = await DeleteAccount(Account_id);
          if (response.success) {
            showSuccessToast("Success!", "Account deleted successfully!");
            window.location.reload();
          } else
            showErrorToast(
              "Error!",
              "Account failed to delete: " + response.message,
            );
        }
      } else showInfoToast("Info!", "Please select account to delete!");
    } catch (error) {
      showErrorToast("Error!", "Account failed to delete!");
    }
  };

  const handleViewAccountClick = () => {
    TimeoutUtility.resetTimeout();
    if (Account_id !== "") navigate(`/Account/ViewAccount/${Account_id}`);
    else showInfoToast("Info!", "Please select account to view.");
  };

  const handleRowSelected = (args) => setAccount_id(args.data.account_id);

  const handleRefresh = async () => {
    if (storeG?.store_id) {
      const resp = await GetAllAccountsByStore(storeG.store_id);
      setAllAccounts(resp.data || []);
    }
  };

  useEffect(() => {
    async function fetchData() {
      if (storeG?.store_id) {
        setloading(true);
        trackPromise(
          GetAllAccountsByStore(storeG.store_id)
            .then((result) => setAllAccounts(result.data || []))
            .catch((err) => console.log(err.message))
            .finally(() => setloading(false)),
        );
      }
    }
    fetchData();
  }, [storeG]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header category="Accounts" title="GENERAL ACCOUNTS" />
      <Container fluid className="g-0 p-0 justify-end">
        <Row xs={2} className="button-row justify-content-end font-normal">
          {userPermID.includes(18) && (
            <Col md="auto p-0">
              <Button text="Add" onClick={handleAddAccountClick} />
            </Col>
          )}
          {userPermID.includes(19) && (
            <>
              <Col md="auto p-0">
                <Button text="Update" onClick={handleEditAccountClick} />
              </Col>
              <Col md="auto p-0">
                <Button text="Delete" onClick={handleDeleteAccountClick} />
              </Col>
            </>
          )}
        </Row>
      </Container>
      <DataGrid
        loading={loading || promiseInProgress}
        data={AllAccounts}
        cols={accGrid}
        handleRowSelected={handleRowSelected}
        handleDoubleClick={userPermID.includes(17) && handleViewAccountClick}
        persistant={true}
        handleRefresh={handleRefresh}
      />
    </div>
  );
};

export default Account;
